"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var cache_1 = require("./cache");
function getMountNode(element) {
    if (cache_1.getCache('root')) {
        return cache_1.getCache('root');
    }
    if (element) {
        // string treated as 'id'
        if (typeof element === 'string') {
            return document.querySelector("#" + element);
        }
        // function, return value
        if (typeof element === 'function') {
            return element();
        }
        return element;
    }
    var ICE_CONTAINER = document.querySelector('#ice-container');
    if (!ICE_CONTAINER) {
        throw new Error('Current page does not exist <div id="ice-container"></div> element.');
    }
    return ICE_CONTAINER;
}
exports.default = getMountNode;
